import { ArgValidator} from '../Utils/ArgValidator';

export class Section {
    public static showField(field: string, focusField: string) {
        ArgValidator.ensureStringIsNotNullOrEmpty(field, 'field');

        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    public static hideField(field: string) {
        ArgValidator.ensureStringIsNotNullOrEmpty(field, 'field');

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        $(label).closest(".form-group").removeClass("gray");
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Widgets/Section.ts
 **/